import { css } from 'styled-components';

export const fontFaces = css`
  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Thin.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Thin.woff')
        format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ThinItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ThinItalic.woff')
        format('woff');
    font-weight: 100;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraLight.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraLight.woff')
        format('woff');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraLightItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraLightItalic.woff')
        format('woff');
    font-weight: 200;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Light.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Light.woff')
        format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-LightItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-LightItalic.woff')
        format('woff');
    font-weight: 300;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Regular.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Regular.woff')
        format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Italic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Italic.woff')
        format('woff');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Medium.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Medium.woff')
        format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-MediumItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-MediumItalic.woff')
        format('woff');
    font-weight: 500;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-SemiBold.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-SemiBold.woff')
        format('woff');
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-SemiBoldItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-SemiBoldItalic.woff')
        format('woff');
    font-weight: 600;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Bold.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Bold.woff')
        format('woff');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-BoldItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-BoldItalic.woff')
        format('woff');
    font-weight: 700;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraBold.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraBold.woff')
        format('woff');
    font-weight: 800;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraBoldItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-ExtraBoldItalic.woff')
        format('woff');
    font-weight: 800;
    font-style: italic;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Black.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-Black.woff')
        format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Inter';
    src: url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-BlackItalic.woff2')
        format('woff2'),
      url('https://s3.glbimg.com/v1/AUTH_940a089d16ce40569f970f01154c2a6f/shared-styles/fonts/Inter-BlackItalic.woff')
        format('woff');
    font-weight: 900;
    font-style: italic;
    font-display: swap;
  }
`;
